import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { Cars } from '../models/cars.model';
import { CarsRepository } from '../repositories/cars.repository';

export class GetMoreCarsUseCase implements UseCase<void, Cars> {
    constructor(private readonly repository: CarsRepository) {}

    execute(): Observable<Cars> {
        return this.repository.getMoreCars();
    }
}
